export default __webpack_public_path__ + "static/media/ossscreen15.7f5b1430.png";